import { render, staticRenderFns } from "./List.vue?vue&type=template&id=d25ec0c6&"
import script from "../../models/external-points/list.ts?vue&type=script&lang=ts&"
export * from "../../models/external-points/list.ts?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports